import { useEffect, useState } from 'react';
import MainLayout from '../layouts/MainLayout';
import { searchTicketsbyPlate } from '../api/api';
import moment from 'moment';
import { useLocation } from 'react-router-dom';

const TicketsPage = () => {
  const [tickets, setTickets] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 10;
  const [search, setSearch] = useState('');
  const [searched, setSearched] = useState(false);

  // Modal control state
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [searchScreenVisible, setSearchScreenVisible] = useState(true);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const location = useLocation();
  const handlePrev = () => {
    if (page > 0) setPage(page - 1);
  };

  useEffect(() => {
    // runs every time navigation happens (even to same route, because key changes)
    setSearch('');
    setSearched(false);
    setSearchScreenVisible(true);
  }, [location.key]);

  const handleNext = () => {
    if (page < totalPages - 1) setPage(page + 1);
  };


// Parse "YYYY-MM-DDTHH:mm[:ss][.ms][Z|±HH:MM]" as LOCAL wall-clock, ignoring TZ info
const parseLocalIgnoringTZ = (value) => {
  if (value instanceof Date) {
    return new Date(
      value.getFullYear(),
      value.getMonth(),
      value.getDate(),
      value.getHours(),
      value.getMinutes(),
      value.getSeconds(),
      value.getMilliseconds()
    );
  }
  if (typeof value !== 'string') return new Date(NaN);

  const m = value.match(
    /^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,3}))?)?/
  );
  if (!m) return new Date(NaN);

  const [, y, mo, d, h, mi, s = '0', ms = '0'] = m;
  const ms3 = (ms + '000').slice(0, 3); // pad to milliseconds
  return new Date(+y, +mo - 1, +d, +h, +mi, +s, +ms3); // LOCAL time
};

const groupTickets = (tickets) => {
  const now = new Date(); // local "now"
  const past = [];
  const current = [];
  const future = [];

  tickets.forEach((ticket) => {
    const start = parseLocalIgnoringTZ(ticket.startTime);
    const end = parseLocalIgnoringTZ(ticket.endTime);

    if (end < now) {
      past.push(ticket);
    } else if (start <= now && end >= now) {
      current.push(ticket);
    } else if (start > now) {
      future.push(ticket);
    }
  });
// only return non-empty groups, except "current" which should always be there
  const groups = [];
  groups.push({ type: "current", tickets: current });
  if (future.length > 0) groups.push({ type: "future", tickets: future });
  if (past.length > 0) groups.push({ type: "past", tickets: past });

  setSearchScreenVisible(false);

  return groups;
};

  const searchTickets = async () => {
    try {
      const res = await searchTicketsbyPlate(page + 1, limit, search);
      const grouped = groupTickets(res.results);
      setTickets(grouped);
      setTotalPages(res.totalPages);
      setTotal(res.total);
      setSearched(true);
    } catch (err) {
      console.error('Failed to fetch tickets:', err);
    }
  };

  const start = page * limit + 1;
  const end = Math.min((page + 1) * limit, total);

  return (
    <MainLayout>
      {searched && <div className="overflow-x-auto mt-6">
        <div className='mb-4'>
          <h1 className="text-2xl font-bold mt-1">Registered Vehicles</h1>
        </div>

        {tickets.map((group, idx) => (
          <div key={idx} className="mb-6">
            <h2 className="text-lg font-semibold capitalize mb-2">{group.type} Registrations</h2>
            {/* <table className="min-w-full border border-gray-600 rounded">
              <thead>
                <tr className="text-left text-xs sm:text-sm font-semibold text-white">
                  <th className="p-4">PLATE NUMBER</th>
                  <th className="p-4">UNIT NUMBER</th>
                  <th className="p-4">BUILDING</th>
                  <th className="p-4">START TIME</th>
                  <th className="p-4">END TIME</th>
                  <th className="p-4">ACTION</th>
                </tr>
              </thead>
              <tbody>
                {group.tickets.map((ticket, i) => (
                  <tr key={i} className="text-xs border border-gray-600 rounded">
                    <td className="p-4">{ticket.plateNumber}</td>
                    <td className="p-4">{ticket.unitNumber}</td>
                    <td className="p-4">{ticket.building.name}</td>
                    <td className="p-4">{moment.parseZone(ticket.startTime).format('DD/MM/YY HH:mm')}</td>
                    <td className="p-4">{moment.parseZone(ticket.endTime).format('DD/MM/YY HH:mm')}</td>
                    <td>
                      <button
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded me-3"
                        onClick={() => {
                          setSelectedTicket(ticket);
                          setEditModalVisible(true);
                        }}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
                {group.tickets.length === 0 && (
                  <tr>
                    <td colSpan="6" className="p-4 text-center text-gray-400">No Registrations Found</td>
                  </tr>
                )}
              </tbody>
            </table> */}
            <table className="min-w-full border border-gray-600 rounded text-xs sm:text-sm md:text-base">
              <thead>
                <tr className="text-left font-semibold text-white">
                  <th className="p-2 md:p-4">PLATE NUMBER</th>
                  <th className="p-2 md:p-4">UNIT NUMBER</th>
                  <th className="p-2 md:p-4">BUILDING</th>
                  <th className="p-2 md:p-4">START TIME</th>
                  <th className="p-2 md:p-4">END TIME</th>
                  <th className="p-2 md:p-4">ACTION</th>
                </tr>
              </thead>
              <tbody>
                {group.tickets.map((ticket, i) => (
                  <tr key={i} className="border border-gray-600">
                    <td className="p-2 md:p-4">{ticket.plateNumber}</td>
                    <td className="p-2 md:p-4">{ticket.unitNumber}</td>
                    <td className="p-2 md:p-4">{ticket.building.name}</td>
                    <td className="p-2 md:p-4">
                      {moment.parseZone(ticket.startTime).format('DD/MM/YY HH:mm')}
                    </td>
                    <td className="p-2 md:p-4">
                      {moment.parseZone(ticket.endTime).format('DD/MM/YY HH:mm')}
                    </td>
                    <td className="p-2 md:p-4">
                      <button
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 md:py-2 md:px-4 rounded"
                        onClick={() => {
                          setSelectedTicket(ticket);
                          setEditModalVisible(true);
                        }}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
                {group.tickets.length === 0 && (
                  <tr>
                    <td colSpan="6" className="p-4 text-center text-gray-400">No {group.type} Registrations Found</td>
                  </tr>
                )}
              </tbody>
            </table>

          </div>
        ))}

        {/* Pagination */}
        <div className="flex justify-between items-center text-xs sm:text-sm text-gray-600 mt-4 sm:px-4">
          <span>Rows per page: <span className="font-medium">{limit}</span></span>
          <span>{start}–{end} of {total}</span>
          <div className="space-x-2">
            <button
              onClick={handlePrev}
              disabled={page === 0}
              className={`px-2 py-1 rounded ${page === 0 ? 'text-gray-400' : 'text-blue-600 hover:underline'}`}
            >
              Prev
            </button>
            <button
              onClick={handleNext}
              disabled={page >= totalPages - 1}
              className={`px-2 py-1 rounded ${page >= totalPages - 1 ? 'text-gray-400' : 'text-blue-600 hover:underline'}`}
            >
              Next
            </button>
          </div>
        </div>
      </div>}

      {searchScreenVisible && (
        <div className="flex items-center justify-center">
          <div className="bg-[#212121] p-4 md:p-6 rounded w-[95%] sm:w-96">

            {/* <div className="bg-[#212121] p-6 rounded w-96"> */}
            <h2 className="text-lg sm:text-xl font-bold mb-4">Search Vehicle</h2>
            <div>
              <input
                type="text"
                name="plateNumber"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded bg-black text white"
                placeholder="Enter license plate number"
              />
            </div>
            <div className="flex justify-end mt-6 space-x-2">
              <button
                onClick={() => {
                  searchTickets();
                }}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Search
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal (unchanged) */}
      {editModalVisible && selectedTicket && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-[#212121] text-white rounded-xl shadow-lg p-6 w-[90%] max-w-md md:max-w-2xl max-h-[80vh] overflow-y-auto">
            {/* <div className="bg-[#212121] p-4 md:p-6 rounded shadow-md w-[95%] md:w-1/2 max-h-[90vh] overflow-y-auto"> */}

            {/* <div className="bg-[#212121] p-6 rounded shadow-md w-1/2"> */}
            <h2 className="text-lg sm:text-xl font-bold mb-4">View Registered Vehicle Details</h2>
            <form className="space-y-4">
              {/* Building */}
              <div>
                <label className="text-xs sm:text-sm block mb-1 text-left">Site ID/Building Street Name : {selectedTicket.building.name}</label>
                {/* <input
                  type="text"
                  name="buildingId"
                  value={selectedTicket.building.name}
                  className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                  disabled
                /> */}
              </div>

              {/* Email */}
              {selectedTicket.email && (
                <div>
                  <label className="text-xs sm:text-sm block mb-1 text-left">Email : {selectedTicket.email}</label>
                  {/* <input
                    type="email"
                    name="email"
                    value={selectedTicket.email}
                    className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                    disabled
                  /> */}
                </div>
              )}

              {/* Unit */}
              <div>
                <label className="text-xs sm:text-sm block mb-1 text-left">Unit Number : {selectedTicket.unitNumber}</label>
                {/* <input
                  type="text"
                  name="unitNumber"
                  value={selectedTicket.unitNumber}
                  className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                  disabled
                /> */}
              </div>

              {/* License Plate */}
              <div>
                <label className="text-xs sm:text-sm block mb-1 text-left">License Plate Number : {selectedTicket.plateNumber}</label>
                {/* <input
                  type="text"
                  name="plateNumber"
                  value={selectedTicket.plateNumber}
                  className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                  disabled
                /> */}
              </div>

              {/* Start Time */}
              <div>
                <label className="text-xs sm:text-sm block mb-1 text-left">Start Time : {moment.parseZone(selectedTicket.startTime).format('MMMM D, YYYY [at] h:mma')}</label>
                {/* <input
                  type="text"
                  name="startTime"
                  value={moment(selectedTicket.startTime).format('MMMM D, YYYY [at] h:mma')}
                  className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                  disabled
                /> */}
              </div>

              {/* End Time */}
              <div>
                <label className="text-xs sm:text-sm block mb-1 text-left">End Time : {moment.parseZone(selectedTicket.endTime).format('MMMM D, YYYY [at] h:mma')}</label>
                {/* <input
                  type="text"
                  name="endTime"
                  value={moment(selectedTicket.endTime).format('MMMM D, YYYY [at] h:mma')}
                  className="w-full px-3 py-2 bg-black border border-gray-700 rounded text-white"
                  disabled
                /> */}
              </div>

              <div className="flex justify-end mt-6 space-x-2">
                <button
                  onClick={() => setEditModalVisible(false)}
                  className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default TicketsPage;
